import { useContext } from 'react';

import FirebaseAuthContext from 'containers/FirebaseAuthContext';

const useFirebase = () => {
  return useContext(FirebaseAuthContext.Context);
};

export default useFirebase;
